import React, { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useModal } from 'store/modal';
import UpdateEntity from 'components/crud/UpdateEntity';
import UserForm from '../../components/UserForm';
import { IDropdowns, IInputs } from '../../components/types';
import { IUser } from '../../types';

interface IProps {
  user: IUser;
  userDataOptions: IDropdowns;
}

const EditForm: FC<IProps> = ({ user, userDataOptions }: IProps) => {
  const { id } = useParams<{ id: string }>();
  const { showModal } = useModal();

  const accountStatus = userDataOptions.account_status.find(option => user!.account_status === option.value);

  const methods = useForm<IInputs>({
    defaultValues: {
      ...user,
      account_status: accountStatus,
    },
  });

  return (
    <UpdateEntity
      id={id}
      entity="users"
      methods={methods}
      onSuccess={(res: any) => {
        const { first_name: firstName, last_name: lastName } = res.data;
        showModal({
          type: 'success',
          content: (
            <>
              Редактирахте оператор&nbsp;
              <span className="font-weight-bold text-break">
                {firstName} {lastName}
              </span>
              .
            </>
          ),
        });
      }}
      queryKey={['user', { id }]}
      onSuccessPushToLink="/users"
    >
      {(update: any) => {
        return (
          <UserForm
            methods={methods}
            handleSubmit={data => {
              const formatData = {
                ...data,
                account_status: data.account_status.value,
              };
              return update(formatData);
            }}
            btnLabel="Запази"
            userDataOptions={userDataOptions}
          />
        );
      }}
    </UpdateEntity>
  );
};

export default EditForm;
